import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MODULE_FEATURE_KEY } from './keys';
import { moduleReducer } from './reducers/module.reducer';
import { ModuleEffects } from './effects/module.effects';
import { NextModuleBridge } from './bridges/next_module.bridge';

export const moduleStoreProviders = [provideState(MODULE_FEATURE_KEY, moduleReducer), provideEffects(ModuleEffects, NextModuleBridge)];

export { ModuleFacade } from './facades/module.facade';
export { moduleCleanup } from './guards/cleanup.guard';
export * from './models';
export { moduleActions } from './actions/module.actions';
